import { useLocation } from 'react-router-dom';
import emisLogo from '../../assets/images/emis_logo_1.png';
import govtLogo from '../../assets/images/GOVT_LOGO.png';
import '../../styles/policy.scss';

export default function PolicyPage() {
  const { pathname } = useLocation();
  const isPrivacyPolicy = pathname === '/auth/privacy_policy';

  return (
    <>
      <header className="ploicyheader">
        <div className="container-fluid">
          <div className="policy-heder">
            <div className="row">
              <div className="col-md-4">
                <div className="policy-guld">
                  <img className="img-fluid" src={emisLogo} alt="EMIS Logo" />
                </div>
              </div>
              <div className="col-md-8">
                <div className="login-sub-container mx-2">
                  <h1>Educational Management Information System</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {isPrivacyPolicy ? (
        <div className="policy-guidlines">
          <div className="container-fluid">
            <div className="card">
              <div className="privacy-policy mx-2 my-4">
                <div className="container-fluid">
                  <h2>Privacy Policy</h2>
                  <img src={govtLogo} alt="Govt Logo" />
                  <p>
                    The Government of Tamil Nadu Website does not automatically
                    capture any specific personal information from you without
                    your consent, (like name, phone number or e-mail address),
                    that allows us to identify you individually.
                  </p>
                  <p>
                    If the Information Technology Department requests you to
                    provide personal information, for registration or other
                    activities, you will be informed for the particular purposes
                    for which the information is gathered and adequate security
                    measures will be taken to protect your personal information.
                  </p>
                  <p>
                    We do not sell or share any personally identifiable
                    information volunteered on this Portal site to any third
                    party (public/private). Any information provided to this
                    Portal will be protected from loss, misuse, unauthorized
                    access or disclosure, alteration, or destruction to the
                    extent possible.
                  </p>
                  <p>
                    This portal gathers certain information about the User, such
                    as Internet protocol (IP) addresses, domain name, browser
                    type, operating system, the date and time of the visit and
                    the pages visited. However, no attempt is made to link these
                    addresses with the identity of individuals visiting this
                    site unless an attempt to damage the site has been detected
                    or the department wants such information for any specific
                    queries.
                  </p>
                  <p>Hyper Linking Policy</p>
                  <p>Links to external websites/portals</p>
                  <p>
                    At many places in this Portal, you shall find links to other
                    websites/portals. These links have been placed after careful
                    scrutiny. These links have been placed for users
                    convenience. NIC/Organisation / Department are not
                    responsible for the contents and reliability of the linked
                    websites and does not necessarily endorse the views
                    expressed in them. Mere presence of the link or its listing
                    on this Portal should not be assumed as endorsement of any
                    kind. We cannot guarantee that these links will work all the
                    time and we have no control over availability of linked
                    pages.
                  </p>
                  <p>Links to this Portal by other websites</p>
                  <p>
                    We do not object to you linking directly to the information
                    that is hosted on this Portal and no prior permission is
                    required for the same. However, we would like you to inform
                    us about any links provided to this Portal so that you can
                    be informed of any changes or updation that are carried on
                    therein. Also, we do not permit our pages to be loaded into
                    frames on any third party sites. The pages belonging to this
                    Portal must load into a newly opened browser window of the
                    User.
                  </p>
                  <p>Copyright Policy</p>
                  <p>
                    The contents published in this portal are primarily owned by
                    the various Departments of Government of Tamil Nadu.
                    Material featured on this Portal may be reproduced free of
                    charge after taking proper permission from the respective
                    Organisation / Department. However, the material has to be
                    reproduced accurately and not to be used in a derogatory
                    manner or in a misleading context and as per the guidelines
                    provided by the respective Section / Department. Wherever
                    the material is being published or issued to others, the
                    source must be prominently acknowledged. However, the
                    permission to reproduce this material shall not extend to
                    any material which is identified as being copyright of a
                    third party. Authorisation to reproduce such material must
                    be obtained from the departments/copyright holders
                    concerned.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="policy-guidlines">
          <div className="container-fluid">
            <div className="card">
              <div className="privacy-policy mx-2 my-4">
                <div className="container-fluid">
                  <h2>
                    Information about the eGovernment/IT Department/respective
                    Department
                  </h2>
                  <img src={govtLogo} alt="Govt Logo" />
                  <p>
                    Education is the process by which a society transmits its
                    accumulated knowledge skills and values from one generation
                    to another. Education must provide the means and
                    opportunities to enhance the child{"'"}s creative expression
                    and the capacity for aesthetic appreciation. Education gives
                    knowledge about the world around us. It makes children
                    capable of interpreting things in the right perspective.
                  </p>
                  <h5>Vision</h5>
                  <p>
                    To achieve universalisation of education at both elementary
                    and secondary levels by providing burden less quality
                    education through joyful learning and to provide basic
                    infrastructure coupled with safety and security for the well
                    being of the children.
                  </p>
                  <h5>Objectives</h5>
                  <p>
                    To provide universal access, equity, quality at primary,
                    upper primary, secondary and higher secondary level.
                  </p>
                  <p>
                    To strive for all round development of the child. To evolve
                    curriculum and evaluation procedures in conformity with the
                    values enshrined in the Constitution.
                  </p>
                  <p>
                    To build the child{"'"}s knowledge, potential talent and
                    develop the child{"'"}s physical and mental abilities to the
                    fullest extent.
                  </p>
                  <p>
                    To provide required infrastructure to ensure the comfort of
                    each and every child in school. To provide a conducive
                    learning environment through learning activities, discovery
                    and exploration in a child friendly and child centred
                    manner.
                  </p>
                  <p>
                    To provide quality education as far as possible in the child
                    {"'"}s own mother tongue.
                  </p>
                  <p>
                    To provide abundant opportunities for the child to express
                    itself without any fear.
                  </p>
                  <p>
                    To make examinations more flexible and integrated in
                    classroom life by implementing continuous and comprehensive
                    evaluation in phases, to remove the anxiety and stress
                    caused by terminal examinations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
